import { render, staticRenderFns } from "./editStaffWorkingHours.vue?vue&type=template&id=372df7c3&"
import script from "./editStaffWorkingHours.vue?vue&type=script&lang=js&"
export * from "./editStaffWorkingHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports